export default class Timeout {

    private id: ReturnType<typeof setTimeout> | null = null;
    private delay: number;

    constructor(delay: number = 1000) {
        this.delay = delay;
    }

    run(callback: () => void): void {
        this.clear();
        this.id = setTimeout(callback, this.delay);
    }

    clear(): void {
        if (null !== this.id) {
            clearTimeout(this.id);
        }
    }

}
